"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconLeafOutline = props => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  viewBox: "0 0 18 18",
  ...props,
  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
      id: "loc",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "m1440 0v1892h-1440v-1892h1440z"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
      id: "lob",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "m17 0v8.4869c0 2.3823-0.82202 4.3967-2.466 6.0433s-3.6553 2.4699-6.034 2.4699c-1.0144 0-1.972-0.16641-2.8727-0.49923-0.90072-0.33282-1.7184-0.80577-2.4529-1.4189l-1.5741 1.5502c-0.1749 0.17517-0.3804 0.26275-0.61651 0.26275-0.23611 0-0.44162-0.087584-0.61651-0.26275-0.1749-0.17517-0.26235-0.37661-0.26235-0.60433s0.087449-0.43792 0.26235-0.6306l1.5478-1.5765c-0.61214-0.7357-1.0844-1.5502-1.4167-2.4436s-0.49846-1.8568-0.49846-2.8903c0-2.3648 0.82202-4.3704 2.466-6.017 1.644-1.6466 3.6553-2.4699 6.034-2.4699h8.5zm-1.8102 1.7867h-6.6898c-1.8539 0-3.4324 0.6525-4.7353 1.9575-1.303 1.305-1.9545 2.8859-1.9545 4.7427 0 0.77074 0.12243 1.5064 0.36728 2.2071 0.24486 0.70067 0.57716 1.3225 0.99691 1.8655l5.588-5.5703c0.1749-0.17517 0.3804-0.26275 0.61651-0.26275 0.23611 0 0.44162 0.087584 0.61651 0.26275 0.1749 0.17517 0.26235 0.38537 0.26235 0.6306 0 0.24523-0.087448 0.45544-0.26235 0.6306l-5.5617 5.5703c0.55967 0.4204 1.1849 0.75322 1.8758 0.99845s1.421 0.36785 2.1906 0.36785c1.8539 0 3.4324-0.64812 4.7353-1.9444 1.303-1.2962 1.9545-2.8815 1.9545-4.7558v-6.7002z"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
      id: "loa",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "m21.474 0v21.474h-21.474v-21.474h21.474z"
      })
    })]
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      clipPath: "url(#loc)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            clipPath: "url(#lob)",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              points: "0 0 17 0 17 17 0 17"
            })
          })
        })
      })
    })
  })]
});
var _default = exports.default = (0, _withIcon.default)('IconLeafOutline')(IconLeafOutline);